import { G2FSSContainer } from 'components/common/styled';
import styled from 'styled-components';

export const CustomerContainer = styled(G2FSSContainer)`
    flex: 1;
    justify-content: space-between;
`;

export const CustomerHeadingContainer = styled(G2FSSContainer)``;

export const CustomerReportContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    width: 100%;
`;

export const CustomerButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    a {
        text-decoration: none;
    }
`;

export const CustomerTopContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const CustomerBottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
